import { render, staticRenderFns } from "./fl44-unknown-volume-notice-card.vue?vue&type=template&id=7c50923e&scoped=true&"
import script from "./fl44-unknown-volume-notice-card.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./fl44-unknown-volume-notice-card.vue?vue&type=style&index=0&id=7c50923e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c50923e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c50923e')) {
      api.createRecord('7c50923e', component.options)
    } else {
      api.reload('7c50923e', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-notice-card.vue?vue&type=template&id=7c50923e&scoped=true&", function () {
      api.rerender('7c50923e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-notices/partials/fl44-unknown-volume-notice-card.vue"
export default component.exports